import type { Variant } from '../gameTypes.js';
import type { PianoChart } from '../pianoChart.js';
import { PALETTE_CRIMSON } from '../builtinPulseMaps/palettes.js';
import { buildBuiltinAudio } from '../builtinPulseMaps/audioFromOnsets.js';
import audioOnsets from '../circlesBuiltinMaps/audio/my-heart.onsets.json' with { type: 'json' };
import { pianoVariantsFromSpec } from './pianoFromOnsets.js';

/**
 * My Heart — Different Heaven & EH!DE (NCS). The fastest track in
 * the catalogue (174 BPM) charted at half-time so the audio onsets
 * land at a humane piano-tile cadence. Demanding even in Normal —
 * worthy of difficulty 4.
 *
 * Synthesised from the Circles onset analysis. See the header doc
 * on {@link import('./01-on-and-on.js').ON_AND_ON_PIANO_VARIANTS}
 * for the curated-MIDI upgrade path.
 */
export const MY_HEART_PIANO_VARIANTS: Record<Variant, PianoChart> = pianoVariantsFromSpec({
  baseSlug: 'my-heart',
  baseTitle: 'My Heart',
  description:
    "Different Heaven & EH!DE's heavy electro at 174 BPM. Fast, dense, demanding — best after you've cleared the easier tier.",
  difficulty: 4,
  totalBeats: 90,
  palette: PALETTE_CRIMSON,
  audio: buildBuiltinAudio({
    src: '/audio/circles/my-heart.mp3',
    attribution: '"My Heart" by Different Heaven & EH!DE [NCS Release] - https://ncs.io/MyHeart',
    data: audioOnsets,
  }),
  onsets: audioOnsets,
  sections: [
    {
      startBeat: 0,
      endBeat: 90,
      selectOpts: { kinds: ['lead', 'snare'], minIntensity: 0.06, minSpacing: 0.5 },
    },
  ],
});
